import { useLocation } from "react-router-dom";
import { ClockCircleFilled, EnvironmentFilled, PhoneFilled } from "@ant-design/icons";
import { Divider } from "antd";
import { GoogleMap } from "./GoogleMap";
import {FormHorario} from "../molecules/forms/FormHorario"
import "../../Styles/Web.css"
export const WebContact = ({title, map, location, logo, color}) => {

    return (
        <div className="block" id="contacto">
        <h1 className='block-title'>{title}</h1>        
        <div style={{borderRadius:'10px', height:'6px', width: '250px', margin:'10px', background:`linear-gradient(to right, transparent, ${color})`}}/>                
        
        <div className="web-contact-map">
            <div className="web-contact" style={{position:'relative', backgroundColor: `white`, borderRadius: '15px', display: 'flex', flexDirection: 'column', padding: '20px', gap: '20px' }}>
                <div >
                    <div className="logo" style={{position:'absolute', right:30, display:'none'}}>
                        <img src={logo} />
                    </div>
                    <h3> <PhoneFilled style={{ color: `${color}`, marginRight: '15px' }} />
                        Teléfono
                    </h3>
                    <div style={{ marginLeft: '30px' }}>{location?.primaryPhone}</div>
                </div>
                <div>
                    <h3 style={{ textAlign: 'start' }}>
                        <div><EnvironmentFilled style={{ color: `${color}`, marginRight: '15px' }} />Dirección</div>                            
                    </h3>
                    <div style={{ marginLeft: '30px' }}>{location?.addressLine}, {location?.postalCode}</div>                            
                    <div style={{ marginLeft: '30px' }}>{location?.locality},  {location?.administrativeArea}</div>
                </div>

                <Divider style={{ backgroundColor: `${color}44` }}  />
                <div style={{ textAlign: 'start' }}>
                        
                    <h3><ClockCircleFilled style={{ color: `${color}`, marginRight: '15px' }} />Horario</h3>
                    {location?.regularHours?.length > 0 && 
                        <div style={{ marginLeft: '30px', width:'240px' }}>
                            <FormHorario title="Lunes" regularHour={location?.regularHours[0]} />
                            <FormHorario title="Martes" regularHour={location?.regularHours[1]} />
                            <FormHorario title="Miércoles" regularHour={location?.regularHours[2]} />
                            <FormHorario title="Jueves" regularHour={location?.regularHours[3]} />
                            <FormHorario title="Viernes" regularHour={location?.regularHours[4]} />
                            <FormHorario title="Sábado" regularHour={location?.regularHours[5]} />
                            <FormHorario title="Domingo" regularHour={location?.regularHours[6]} />
                        </div>
                    }
                </div>
            </div>

            {map && <GoogleMap location={location} />}
        </div>
    </div>

    )

}
